import styled from 'styled-components'

export const DropText = styled.p`
  /* border: solid 2px;
  border-style: dashed;
  border-color: #be9137; */
`

export const ImageBox = styled.div`
  height: clamp(1vh, 60vw, 60vh);
  width: clamp(10vw, 70vw, 45rem);
  min-width: 100%;
  padding: 0.7rem;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--light);
  border-radius: var(--base-border-radius);
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'unset')};
  transition: border-color 0.3s;

  border: 1px dashed
    ${({ isDragActive }) => (isDragActive ? '#be9137' : '#be9137')};

  &:hover {
    border-color: #be9137;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: scale-down;
  }

  @media (max-width: 575px) {
    height: clamp(1vh, 60vw, 76vh);
  }
`

export const DropArea = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`
